module.exports = __webpack_public_path__ + "media/img/help_center/Institution_User_Settings_04-35b7ac3a6d1d0c94e609fb27ba6b0526.jpg";